import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import BcTable from '@/components/Table.vue';
// @ts-ignore
import BcSnackbar, { CBcSnackbar } from '@/components/BcSnackbar.vue';
// @ts-ignore
import BcDialog from '@/components/Dialog.vue';
const { EleResize } = require('@/assets/js/eresize.js');
let ProductInventoryStatistic = class ProductInventoryStatistic extends Vue {
    constructor(props) {
        super(props);
        this.snackbar = new CBcSnackbar();
        // 设备型号
        this.tableOptions = {
            visible: false,
            loading: false,
            desserts: [],
            headers: [
                {
                    text: '产品线',
                    align: 'center',
                    sortable: true,
                    value: 'productLine',
                    width: '100',
                },
                {
                    text: '产品型号',
                    align: 'center',
                    sortable: true,
                    value: 'model',
                    width: '140',
                },
                {
                    text: '产品编号',
                    align: 'center',
                    sortable: true,
                    value: 'productCode',
                    width: '140',
                },
                {
                    text: '产品名称',
                    align: 'left',
                    sortable: true,
                    value: 'productName',
                    width: '220',
                },
                {
                    text: '产品简称',
                    align: 'left',
                    sortable: false,
                    value: 'shortName',
                    width: '180',
                },
                {
                    text: '设备/产品系列',
                    align: 'center',
                    sortable: false,
                    value: 'serial',
                },
                {
                    text: '规格',
                    align: 'start',
                    sortable: false,
                    value: 'specifications',
                },
                {
                    text: '库存量',
                    align: 'center',
                    sortable: true,
                    value: 'inventoryQuantity',
                    width: '100',
                },
                {
                    text: '待出库',
                    align: 'center',
                    sortable: true,
                    value: 'busOutQuantity',
                    width: '100',
                },
                {
                    text: '最后入库时间',
                    align: 'center',
                    sortable: false,
                    value: 'inboundDate',
                    width: '175',
                },
                //   {
                //     text: "最后出库时间",
                //     align: "center",
                //     sortable: false,
                //     value: "outboundDate",
                //     width: "175",
                //   },
                {
                    text: '操作',
                    align: 'center',
                    sortable: false,
                    value: 'action',
                    width: '105',
                },
            ],
            echartsOption: {
                domKey: 'charts_inventory',
                title: {
                    show: false,
                    textStyle: {
                        color: '#bcbcbc',
                    },
                    text: '没有数据',
                    left: 'center',
                    top: 'center',
                },
                color: ['#5793f3', '#d14a61', '#675bba'],
                tooltip: {
                    trigger: 'axis',
                },
                toolbox: {
                    feature: {
                        dataView: { show: true, readOnly: false },
                        restore: { show: true },
                        saveAsImage: {},
                    },
                },
                dataZoom: [
                    {
                        show: true,
                        realtime: true,
                    },
                    {
                        type: 'inside',
                        realtime: true,
                    },
                ],
                xAxis: {
                    type: 'category',
                    axisTick: {
                        alignWithLabel: true,
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#61A0A8',
                        },
                    },
                    axisPointer: {
                        label: {
                            formatter: (params) => `设备型号: ${params.value}`,
                        },
                    },
                    data: [],
                },
                yAxis: [
                    {
                        name: '库存量',
                        position: 'left',
                        silent: false,
                        splitLine: {
                            show: false,
                        },
                        type: 'value',
                        axisLabel: {
                            formatter: '{value} 台',
                        },
                    },
                ],
                series: [
                    {
                        data: [],
                        name: '库存量',
                        type: 'bar',
                        barMaxWidth: '40',
                        smooth: true,
                        animationDelay: (idx) => idx * 10,
                        itemStyle: {
                            normal: {
                                color: '#61A0A8',
                                label: {
                                    show: true,
                                    position: 'top',
                                    textStyle: {
                                        // 数值样式
                                        color: '#61A0A8',
                                    },
                                    formatter: '{c} 台',
                                },
                            },
                        },
                    },
                    {
                        data: [],
                        name: '库存量',
                        stack: '库存量',
                        type: 'line',
                        smooth: true,
                        animationDelay: (idx) => idx * 10,
                    },
                ],
                animationEasing: 'elasticOut',
                animationDelayUpdate: (idx) => idx * 5,
            },
        };
        // 库存记录
        this.inventoryTable = {
            headers: [
                {
                    text: '产品线',
                    align: 'left',
                    sortable: false,
                    value: 'productLine',
                    width: '80',
                },
                {
                    text: '产品型号',
                    align: 'center',
                    sortable: false,
                    value: 'model',
                    width: '140',
                },
                {
                    text: '产品名称',
                    align: 'left',
                    sortable: false,
                    value: 'productName',
                    width: '260',
                },
                {
                    text: '库存单类型',
                    align: 'center',
                    sortable: false,
                    value: 'storeType',
                    width: '95',
                },
                {
                    text: '来源/去向',
                    align: 'center',
                    sortable: false,
                    value: 'boundType',
                    width: '120',
                },
                {
                    text: '出/入库时间',
                    align: 'center',
                    sortable: false,
                    value: 'boundDate',
                    width: '175',
                },
                {
                    text: '出/入库数量',
                    align: 'center',
                    sortable: false,
                    value: 'stockInOutQuantity',
                    width: '100',
                },
            ],
            desserts: [],
            loading: false,
        };
        this.searchOptions = {
            keyword: '',
            displayOption: 0,
            timer: null,
            productLine: '',
            productModel: '',
        };
        this.productList = [];
        this.productCategory = [];
        this.putStorageCount = 0; // 待入库数量
        this.quitStorageCount = 0; // 退货待入库数量
        this.dialogDetail = {
            visible: false,
            loading: false,
            queryParams: {
                productLine: '',
                model: '',
            },
        };
        this.inventoryRecords = {
            visible: false,
            loading: false,
            queryParams: {
                productLine: '',
                model: '',
            },
        };
        this.deviceTable = {
            headers: [
                {
                    text: '产品线',
                    align: 'left',
                    sortable: false,
                    value: 'productLine',
                    width: '80',
                },
                {
                    text: '产品类别',
                    align: 'center',
                    sortable: false,
                    value: 'productType',
                    width: '95',
                },
                {
                    text: '设备编号',
                    align: 'left',
                    sortable: false,
                    value: 'deviceCode',
                    width: '150',
                },
                {
                    text: '产品名称',
                    align: 'left',
                    sortable: false,
                    value: 'productName',
                },
                {
                    text: '型号',
                    align: 'center',
                    sortable: false,
                    value: 'model',
                    width: '140',
                },
                {
                    text: '库存数量',
                    align: 'center',
                    sortable: true,
                    value: 'inventory',
                },
                {
                    text: '状况描述',
                    align: 'center',
                    sortable: true,
                    value: 'lastInboundType',
                },
                {
                    text: '最新状态',
                    align: 'center',
                    sortable: false,
                    value: 'deviceStatus',
                    width: '120',
                },
                {
                    text: '最新操作时间',
                    align: 'center',
                    sortable: false,
                    value: 'boundDate',
                    width: '175',
                },
                {
                    text: '操作',
                    align: 'center',
                    sortable: false,
                    value: 'action',
                    width: '105',
                },
            ],
            desserts: [],
            loading: false,
        };
        this.pagination = {
            pageCount: 1,
            pageNow: 1,
            pageArr: [5, 10, 20, 50, '所有'],
            everyPageCount: 10,
            sumDetail: 0,
        };
        // 变量在构造函数内部进行声名赋值
        const that = this;
    }
    async getDataList() {
        const that = this;
        try {
            const res = await that.axios.get('/api/erp/inventory/statistics', {
                params: {
                    keyword: that.searchOptions.keyword,
                    productLine: that.searchOptions.productLine,
                    productModel: (that.searchOptions.productModel || {}).model,
                },
            });
            that.tableOptions.desserts = res.data.result || [];
            const xData = [];
            const yData = [];
            that.tableOptions.desserts.forEach((e) => {
                if (e.inboundDate)
                    e.inboundDate = new Date(e.inboundDate).format('yyyy-MM-dd hh:mm:ss');
                if (e.outboundDate) {
                    e.outboundDate = new Date(e.outboundDate).format('yyyy-MM-dd hh:mm:ss');
                }
                // 库存量计算 入库量 - 出库量
                e.inventoryQuantity = e.inQuantity - e.outQuantity;
                xData.push(e.shortName);
                yData.push(e.inventoryQuantity);
            });
            that.initChars(that.tableOptions.echartsOption, xData, yData);
            //   that.tableOptions.desserts = that.tableOptions.desserts.sort(
            //     (a: any, b: any) => b.inventoryQuantity - a.inventoryQuantity
            //   );
        }
        catch (e) { }
    }
    initChars(option, xData, yData) {
        const that = this;
        if (!option)
            return;
        option.xAxis.data = xData;
        if (yData) {
            if (/object/i.test(typeof yData[0])) {
                for (const index in yData) {
                    option.series[index].data = yData[index];
                }
            }
            else {
                option.series[0].data = yData;
            }
        }
        that.$nextTick(() => that.drawLine(option.domKey, option));
    }
    drawLine(dom, option) {
        const that = this;
        const doc = document;
        const eleResize = EleResize;
        const myChart = that.$echarts.init(doc.getElementById(dom));
        const resizeDiv = doc.getElementById(dom);
        // 绘制图表
        myChart.setOption(option);
        eleResize.on(resizeDiv, () => myChart.resize());
    }
    async searchChange() {
        const that = this;
        clearTimeout(that.searchOptions.timer);
        that.searchOptions.timer = setTimeout(() => {
            that.getDataList();
            that.getOrderStatusTotal();
        }, 300); // 1秒执行一次获取函数 防抖
    }
    /**
     * 获取产品列表
     */
    async getProductList() {
        const that = this;
        const res = await that.axios.get('/api/erp/sales');
        that.productList = (res.data && res.data.result) || [];
        that.productCategory = [];
        if (that.productList.length > 0) {
            // 去重后添加到产品线分类中
            const pList = that.productList.map((o) => o.productLine);
            that.productCategory = pList.filter((value, index, self) => self.indexOf(value) === index) || [];
        }
    }
    /**
     * 获取库存列表
     */
    async getInventoryDataList() {
        const that = this;
        that.deviceTable.loading = true;
        try {
            const res = await that.axios.get('/api/erp/inventory/product', {
                params: {
                    productTypeInfoId: that.dialogDetail.queryParams.productTypeInfoId,
                },
            });
            that.deviceTable.desserts = res.data.result || [];
        }
        catch (e) {
            console.log(e);
        }
        finally {
            that.deviceTable.loading = false;
        }
    }
    /**
     * 获取设备库存出入库记录
     */
    async getInventoryRecordList() {
        const that = this;
        that.inventoryTable.loading = true;
        try {
            const res = await that.axios.get('/api/erp/inventory', {
                params: {
                    page: that.pagination.pageNow,
                    limit: typeof that.pagination.everyPageCount === 'number'
                        ? that.pagination.everyPageCount
                        : that.pagination.sumDetail,
                    productTypeInfoId: that.inventoryRecords.queryParams.productTypeInfoId,
                    deviceCode: that.inventoryRecords.queryParams.deviceCode,
                },
            });
            that.inventoryTable.desserts = res.data.result || [];
            that.pagination.sumDetail = res.data.sum || 0;
            // 分页信息处理
            that.pagination.sumDetail = res.data.sum;
            const pageCount = Math.ceil(res.data.sum / that.pagination.everyPageCount) || 1;
            that.pagination.pageCount = pageCount;
            if (that.pagination.pageNow > pageCount) {
                that.pagination.pageNow = pageCount;
            }
        }
        catch (e) {
            console.log(e);
        }
        finally {
            that.inventoryTable.loading = false;
        }
    }
    /**
     * 显示库存明细
     */
    showDetailClick(row) {
        const that = this;
        that.dialogDetail.visible = true;
        that.dialogDetail.queryParams = {
            productTypeInfoId: row.id,
            productLine: row.productLine,
            model: row.model,
        };
        that.getInventoryDataList();
    }
    /**
     * 显示库存出入记录
     */
    showInventoryRecordsClick(row) {
        const that = this;
        that.inventoryRecords.visible = true;
        that.inventoryRecords.queryParams = {
            productTypeInfoId: row.productTypeInfoId,
            deviceCode: row.deviceCode,
        };
        that.pagination.pageCount = 1;
        that.pagination.pageNow = 1;
        that.pagination.everyPageCount = 10;
        that.pagination.sumDetail = 0;
        that.getInventoryRecordList();
    }
    /**
     * 跳转到入库页面
     */
    storageClick(type) {
        this.$router.push({
            name: 'QualityExamine',
            params: {
                examineResults: '1',
                dataSource: type === 'put' ? '0' : '1',
                orderStatus: '待入库'
            }
        });
    }
    /**
     * 获取订单状态统计
     */
    async getOrderStatusTotal() {
        const that = this;
        await that.axios
            .get('/api/erp/order/quality/statistics')
            .then((res) => {
            const data = res.data && res.data.result || {};
            that.putStorageCount = data.putStorageCount || 0;
            that.quitStorageCount = data.quitStorageCount || 0;
        });
    }
    async mounted() {
        const that = this;
        await that.getProductList();
        await that.getDataList();
        that.getOrderStatusTotal();
    }
};
ProductInventoryStatistic = __decorate([
    Component({
        name: 'ProductInventoryStatistic',
        components: {
            BcSnackbar,
            BcDialog,
            BcTable,
        },
    })
], ProductInventoryStatistic);
export default ProductInventoryStatistic;
